/* src/app/admin-dashboard/svinn-report/svinn-report.component.css */
.divider-cell {
  border-left: 1px solid #ccc;
}
.select-time-period {
  margin-left: 20px;
}
.create-button {
  margin-bottom: 32px;
}
.example-full-width {
  margin-left: 20px;
}
.checkbox {
  margin-left: 20px;
}
.checkbox-text {
  font-size: 10pt;
  padding-top: 0;
}
::ng-deep .checkbox .mdc-label {
  padding: 10px;
  margin: 0;
}
/*# sourceMappingURL=svinn-report.component.css.map */
